export const divideArrayIntoParts = (array, numb = 6) => {
    const nuevoArray = [];
    for (let i = 0; i < array.length; i += numb) {
        nuevoArray.push(array.slice(i, i + numb));
    }
    return nuevoArray;
}